var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operation-history"},[_c('i',{staticClass:"iconfont icon-undo",on:{"click":_vm.undo}}),_c('i',{staticClass:"iconfont icon-redo",on:{"click":_vm.redo}}),_c('i',{staticClass:"iconfont icon-clear",on:{"click":_vm.clear}})])}
var staticRenderFns = []

export { render, staticRenderFns }